import JsSIP from 'jssip/JsSIP';

// Add browser userAgent to JsSIP

JsSIP.C.USER_AGENT += ' Browser - ' + navigator.userAgent;

export default JsSIP;
